"use strict";
import _ from "underscore";
import Auth from "../util/auth";
export default {
  setUserFilterPreference(location, history) {
    const filters = location.query.filters || this.userPreferredFilter();
    const query = { filters, page: void 0 };
    const name = Auth._currentUser.name;
    if (name === "HubTran Admin" || name === "TriumphPay Admin") {
      query.page = location.query.page || 1;
    }
    history.pushState(null, location.pathname, query);
  },
  selectedFilters(location) {
    return location.query.filters || {};
  },
  userPreferredFilter() {
    return Auth._currentUser.settings.preferred_filter || { All: "true" };
  },
  queryWithFilters(filters) {
    return _.extend({}, { filters });
  }
};
